import React from 'react';
import ASSETS from '../../assets';
import TakeControl from '../Home/components/TakeControl';
import Slider from './Slider';

const About = () => {
  return (
    <div className=''>
      <div className='w-full lg:min-h-[calc(100vh_-_24px)] rounded-[24px] bg-l-light-grey 2xl:px-[68px] lg:px-12 px-6  flex flex-col lg:pt-[88px] pt-[100px] lg:pb-0 pb-6'>
        <div className='flex-grow flex lg:flex-row flex-col items-center justify-between gap-6'>
          <div className='lg:flex-1 lg:min-w-[350px]'>
            <p className='xl:text-[48px] xl:leading-[72px] md:text-[32px] md:leading-[48px]  text-3xl text-l-primary font-bold max-w-[50ch] '>
              Get Expert Legal Advice from Anywhere, Anytime
            </p>
            <p className='xl:text-lg text-base text-l-primary font-medium max-w-[50ch] mt-6'>
              Legal Avenue is an online solution to find legal experts without
              hassle. Ditch the old way of booking appointments. No waiting in
              stuffy courts, and no dealing with flawed legal procedures.
              Because we bring authentic and personalized legal help straight to
              you. Whether it’s a business dispute or a family matter, you can
              access expert advice from anywhere, anytime.
            </p>
          </div>
          <div className='flex-1'>
            <img src={ASSETS.hero3} className='ml-auto' alt='' />
          </div>
        </div>
      </div>
      <div className='lg:px-[68px] md:px-12 px-3 lg:my-[120px] my-12'>
        <div className='flex lg:flex-row flex-col lg:items-start items-center justify-between gap-8 mt-[72px]'>
          <div>
            <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold'>
              Mission
            </p>
            <p className='text-base font-medium text-l-primary max-w-[65ch] mt-6'>
              Legal Avenue aims to simplify legal advice with a unique approach.
              Unlike traditional legal systems, our streamlined process allows
              you to seek legal advice with no barriers. Our attorneys are
              dedicated to serve you with reliable and personalized legal help.
              Because we know you deserve more. More support, more confidence,
              and more peace of mind.
            </p>
            <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold lg:mt-20 mt-10'>
              Vision
            </p>
            <p className='text-base font-medium text-l-primary max-w-[65ch] mt-6'>
              We believe access to quality legal help is everyone’s right. No
              matter your race, gender, or social status. Legal Avenue aims to
              empower you with expert legal advice to deal with any legal
              challenges you might be facing. Whether you’re an individual, a
              family, or a business, our expert legal attorneys are here to
              guide you and assist you.
            </p>
            <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold lg:mt-20 mt-10 max-w-[25ch]'>
              Tailored Advice from Specialized Attorneys
            </p>
            <p className='text-base font-medium text-l-primary max-w-[65ch] mt-6'>
              Legal Avenue is an online platform that connects you with expert
              attorneys in minutes. Our ‘Find a Lawyer’ feature allows you to
              find highly specialized attorneys in a few clicks. No more chasing
              lawyers. No more dealing with chaotic legal procedures. At Legal
              Avenue, you’ll get tailored advice no matter what legal issue
              you’re facing.
              <br />
              <br />
              Want legal assistance in family and inheritance matters? Our
              specialized family and inheritance lawyers are happy to help you.
              Looking for a corporate lawyer to help with business disputes? Our
              companies and securities lawyers can help you resolve business
              disputes with confidence. And that’s not all. If you need legal
              advice in other matters such as intellectual property, real
              estate, and taxation, we have specialized attorneys in these areas
              as well.
            </p>
            <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold lg:mt-20 mt-10'>
              What Sets Us Apart
            </p>
            <p className='text-base font-medium text-l-primary max-w-[65ch] mt-6'>
              Diverse Legal Expertise: You can connect with lawyers with diverse
              academic and professional backgrounds. This includes family law,
              property law, business law, and the list goes on. <br />
              <br />
              Streamlined Process: Our appointment booking process is simple and
              efficient. You can easily find a lawyer of your choice and book an
              appointment with them whenever you’re convenient. <br />
              <br />
              Empathy and Integrity: We know legal issues can be stressful.
              That’s why we never compromise on honesty, fairness, and
              professionalism while dealing with clients.
              <br />
              <br />
              <span className='font-semibold text-l-primary'>
                Join Legal Avenue today and experience a new way of handling
                legal matters. It’s fast, easy, and super reliable.{' '}
              </span>
            </p>
          </div>
          <div>
            <div className='flex items-start gap-6'>
              <div className='lg:size-[72px] size-[56px]  min-w-[56px] aspect-square grid place-items-center rounded-full bg-l-green'>
                <img src={ASSETS.hammer} alt='' />
              </div>
              <div>
                <div className='h-[56px] flex items-center'>
                  <p className='text-l-primary font-medium text-2xl'>
                    Diverse Legal Expertise
                  </p>
                </div>
                <p className='text-sm text-l-primary max-w-[40ch] pt-2'>
                  You can connect with lawyers with diverse academic and
                  professional backgrounds. This includes family law, property
                  law, business law, and the list goes on.
                </p>
              </div>
            </div>
            <div className='flex items-start gap-6 mt-[54px]'>
              <div className='lg:size-[72px]  size-[56px] min-w-[56px] aspect-square grid place-items-center rounded-full bg-l-yellow'>
                <img src={ASSETS.setting} alt='' />
              </div>
              <div>
                <div className='h-[56px] flex items-center'>
                  <p className='text-l-primary font-medium text-2xl'>
                    Streamlined Process
                  </p>
                </div>
                <p className='text-sm text-l-primary max-w-[40ch] pt-2'>
                  Our appointment booking process is simple and efficient. You
                  can easily find a lawyer of your choice and book an
                  appointment with them whenever you’re convenient.
                </p>
              </div>
            </div>
            <div className='flex items-start gap-6 mt-[54px]'>
              <div className='lg:size-[72px]  size-[56px] min-w-[56px] aspect-square grid place-items-center rounded-full bg-l-green'>
                <img src={ASSETS.handshake} alt='' />
              </div>
              <div>
                <div className='h-[56px] flex items-center'>
                  <p className='text-l-primary font-medium text-2xl'>
                    Empathy and Integrity
                  </p>
                </div>
                <p className='text-sm text-l-primary max-w-[40ch] pt-2'>
                  We know legal issues can be stressful. That’s why we never
                  compromise on honesty, fairness, and professionalism while
                  dealing with clients.
                </p>
              </div>
            </div>
          </div>
        </div>
        <TakeControl />
        <div className='lg:mt-[120px] mt-12'>
          <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold max-w-[25ch]'>
            Hear What the Team behind Have to Say
          </p>
          <p className='text-base font-medium text-l-primary max-w-[62ch] mt-6'>
            Legal Avenue is an online legal platform that makes law accessible
            for everyone. We truly partner with our clients to help them know
            their legal rights and overcome any legal issue they might be
            facing. And that’s not possible without a reliable and supportive
            team. That’s why, we want to take a moment to introduce our team
            members.
          </p>

          <Slider />
        </div>
      </div>
    </div>
  );
};

export default About;
